import { Box, Typography } from "@mui/material";

export const TableResultCount = ({ value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      mb: 1,
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontWeight: 500,
        color: "text.primary",
      }}
    >
      Results
    </Typography>

    <Box
      sx={{
        px: 1.2,
        fontWeight: 500,
        color: "text.secondary",
      }}
      variant="body2"
    >
      ({value})
    </Box>
  </Box>
);
